module.exports = __webpack_public_path__ + "img/area_thumbnail_211021.2b8c36fa.jpg";